import React from 'react';

const Button = () => {

  return (
    <>
        <button className='form-input-btn' type='submit'>
          Generuj Stopkę
        </button>
    </>
  );
};

export default Button;